import { CHART_PALETTE, CHART_PALETTE_DARK } from "../../constants/chartPalette";

// Enhanced color scheme with better contrast and accessibility
export const CHART_COLORS = {
  greenCharging: CHART_PALETTE.green,
  aiOptimization: CHART_PALETTE.blue,
  userSchedules: CHART_PALETTE.violet,
  powerConsumed: CHART_PALETTE.amber,
  powerOffered: CHART_PALETTE.cyan,
  gridBackground: CHART_PALETTE.gridBackground,
  gridLines: CHART_PALETTE.gridLines,
  textPrimary: CHART_PALETTE.textPrimary,
  textSecondary: CHART_PALETTE.textSecondary,
};

export const CHART_COLORS_DARK = {
  ...CHART_COLORS,
  gridBackground: CHART_PALETTE_DARK.gridBackground,
  gridLines: CHART_PALETTE_DARK.gridLines,
  textPrimary: CHART_PALETTE_DARK.textPrimary,
  textSecondary: CHART_PALETTE_DARK.textSecondary,
};

export const CHART_TITLE = "Schedules and Energy Consumption";

export const FONT_FAMILY = "system-ui, -apple-system, sans-serif";

export const MARGIN = { top: 10, right: 20, bottom: 70, left: 75 };

export const SERIES_CONFIG = [
  {
    key: "greenChargingSetpointPower",
    name: "Green Charging",
    color: CHART_COLORS.greenCharging,
    lineWidth: 2.5,
    stepLeft: true,
    zIndex: 3,
    dashed: false,
    isSetpoint: true,
  },
  {
    key: "smartChargingSetpointPower",
    name: "AI optimization",
    color: CHART_COLORS.aiOptimization,
    lineWidth: 2.5,
    stepLeft: true,
    zIndex: 3,
    dashed: false,
    isSetpoint: true,
  },
  {
    key: "userSetSchedulesSetpointPower",
    name: "User Set Schedules",
    color: CHART_COLORS.userSchedules,
    lineWidth: 2.5,
    stepLeft: true,
    zIndex: 3,
    dashed: false,
    isSetpoint: true,
  },
  {
    key: "energyConsumptionData",
    name: "Power Consumed",
    color: CHART_COLORS.powerConsumed,
    lineWidth: 2,
    stepLeft: false,
    zIndex: 2,
    dashed: false,
    isSetpoint: false,
  },
  {
    key: "powerOffered",
    name: "Power Offered",
    color: CHART_COLORS.powerOffered,
    lineWidth: 2,
    stepLeft: false,
    zIndex: 1,
    dashed: true,
    isSetpoint: false,
  },
];

export const Y_AXIS_PADDING_MULTIPLIER = 1.1;
export const X_AXIS_LABEL_OFFSET = 40;
export const Y_AXIS_LABEL_OFFSET = 60;
export const TOOLTIP_BOTTOM_PADDING = 5;
export const BACKGROUND_BORDER_RADIUS = 8;
